var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasherArmBottomOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 159 39",
    style: {
      enableBackground: "new 0 0 159 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00B7FF;}\r\n\t.st1{fill:#00ADEE;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#FF001C;}\r\n\t.st4{fill:#929497;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.73,
    y: 33.81,
    className: "st4",
    width: 155.55,
    height: 5.19
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 159,
    height: 39
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasherArmBottomOff);
export default __webpack_public_path__ + "static/media/washer_arm_bottom_off.11e9836e2eef059262a458bb61a811ee.svg";
export { ForwardRef as ReactComponent };